import React, { useEffect, useState } from 'react'
import { Drawer } from 'antd'
import { RiCloseLine } from 'react-icons/ri'
import { translations } from '../../utils/constants'

const DeviceDrawer = ({ isVisible, onClose, title, devices, language, vehicleDetails }) => {
    // console.log(devices, 'devices')
    const [devicesData, setDevicesData] = useState([])

    useEffect(() => {
        setDevicesData(devices)
    }, [devices])

    // console.log(devicesData)
    const deviceType = devicesData[0]?.device_type

    const renderDeviceSpecificFields = () => {
        switch (deviceType) {
            case 'router':
                return (
                    <>
                        <div className='inner-information-div'>
                            <div className='info-childern-div'>
                                <div className='inner-information-childern'>
                                    <h3 className='info-heading'>{translations[language]?.apn || 'APN'}</h3>
                                    <p>{devicesData[0]?.apn || '-'}</p>
                                </div>
                            </div>
                            <div className='info-childern-div'>
                                <div className='inner-information-childern'>
                                    <h3 className='info-heading'>{translations[language]?.vpnCertificateNames || 'VPN Certificate Names'}</h3>
                                    <p>{devicesData[0]?.vpn_certificate_names || '-'}</p>
                                </div>
                            </div>
                        </div>
                        <div className='inner-information-div'>
                            <div className='info-childern-div'>
                                <div className='inner-information-childern'>
                                    <h3 className='info-heading'>
                                        {translations[language]?.vpnIP || ''}
                                    </h3>
                                    <p>{devicesData[0]?.vpn_ip || '-'}</p>
                                </div>
                            </div>
                        </div>
                    </>
                )
            case 'passenger-counters':
                return (
                    <>
                        <div className='inner-information-div'>
                            <div className='info-childern-div'>
                                <div className='inner-information-childern'>
                                    <h3 className='info-heading'>{translations[language]?.ip || 'IP'}</h3>
                                    <p>{devicesData[0]?.passenger_ip || '-'}</p>
                                </div>
                            </div>
                            <div className='info-childern-div'>
                                <div className='inner-information-childern'>
                                    <h3 className='info-heading'>{translations[language]?.passengerCounterPositioning || 'Positioning (front, rear, central)'}</h3>
                                    <p>{devicesData[0]?.passenger_counter_positioning || '-'}</p>
                                </div>
                            </div>
                        </div>
                    </>
                )
            case 'validators':
                return (
                    <>
                        <div className='inner-information-div'>
                            <div className='info-childern-div'>
                                <div className='inner-information-childern'>
                                    <h3 className='info-heading'>{translations[language]?.passengerCounterPositioning || 'Positioning (front, rear, central)'}</h3>
                                    <p>{devicesData[0]?.validator_positioning || '-'}</p>
                                </div>
                            </div>
                            <div className='info-childern-div'>
                                <div className='inner-information-childern'>
                                    <h3 className='info-heading'>{translations[language]?.terminalId || 'Terminal ID'}</h3>
                                    <p>{devicesData[0]?.terminal_id || '-'}</p>
                                </div>
                            </div>
                        </div>
                        <div className='inner-information-div'>
                            <div className='info-childern-div'>
                                <div className='inner-information-childern'>
                                    <h3 className='info-heading'>{translations[language]?.ip || 'IP'}</h3>
                                    <p>{devicesData[0]?.validator_ip || '-'}</p>
                                </div>
                            </div>
                            <div className='info-childern-div'>
                                <div className='inner-information-childern'>
                                    <h3 className='info-heading'>{translations[language]?.posSerialNumber || 'POS Serial Number'}</h3>
                                    <p>{devicesData[0]?.pos_serial_number || '-'}</p>
                                </div>
                            </div>
                        </div>
                    </>
                )
            case 'lcd-displays':
                return (
                    <div className='inner-information-div'>
                        <div className='info-childern-div'>
                            <div className='inner-information-childern'>
                                <h3 className='info-heading'>{translations[language]?.ip || 'IP'}</h3>
                                <p>{devicesData[0]?.lcd_ip || '-'}</p>
                            </div>
                        </div>
                    </div>
                )
            case 'mdvr':
                return (
                    <div className='inner-information-div'>
                        <div className='info-childern-div'>
                            <div className='inner-information-childern'>
                                <h3 className='info-heading'>{translations[language]?.ip || 'IP'}</h3>
                                <p>{devicesData[0]?.mdvr_ip || '-'}</p>
                            </div>
                        </div>
                    </div>
                )
            case 'xpad':
                return (
                    <div className='inner-information-div'>
                        <div className='info-childern-div'>
                            <div className='inner-information-childern'>
                                <h3 className='info-heading'>{translations[language]?.ip || 'IP'}</h3>
                                <p>{devicesData[0]?.xpad_ip || '-'}</p>
                            </div>
                        </div>
                    </div>
                )
            default:
                return null
        }
    }

    return (
        <Drawer
            title={<span className="capitalized-name">{title}</span>}
            visible={isVisible}
            onClose={onClose}
            width={750}
            placement='right'
            closable={true}
            className='custom-drawer'
            closeIcon={<span className='custom-close-icon'><RiCloseLine /></span>}
            style={{ zIndex: 1000 }}
        >
            <div className='custom-modal-inner-container'>
                {/* <div>
                        
                        <div className='information-section-drawer'>
                            <div>
                                {renderDeviceSpecificFields()}
                            </div>
                        </div>
                    </div> */}

                {devicesData.map((device) => (
                    <div key={device.id} className='device-info-section'>
                        <div className="device-info-inline">

                            <div className='flex-device-info'>
                                {/* <div className="device-info-item">
                                    <h3 className='info-heading'>{translations[language]?.deviceName}</h3>
                                    <p>{device?.device_name}</p>
                                </div> */}
                                <div className="device-info-item">
                                    <h3 className='info-heading'>{translations[language]?.typeOfDevice}</h3>
                                    <p>{device?.device_type ? device.device_type.toUpperCase() : '-'}</p>
                                </div>
                                <div className="device-info-item">
                                    <h3 className='info-heading'>{translations[language]?.model || 'Model'}</h3>
                                    <p>{device?.model}</p>
                                </div>
                            </div>
                            <div className='flex-device-info'>
                                <div className="device-info-item">
                                    <h3 className='info-heading'>{translations[language]?.brand || 'Brand'}</h3>
                                    <p>{device?.brand}</p>
                                </div>
                                <div className="device-info-item">
                                    <h3 className='info-heading'>{translations[language]?.immediateAssociationToVehicle}</h3>
                                    <p>{vehicleDetails?.vehicle_name}</p>
                                </div>
                            </div>

                            <div className='flex-device-info'>
                                <div className="device-info-item">
                                    <h3 className='info-heading'>{translations[language]?.installationDate}</h3>
                                    <p>{device?.installation_date ? new Date(device?.installation_date).toLocaleDateString('en-GB') : ''}</p>
                                </div>
                                <div className="device-info-item">
                                    <h3 className='info-heading'>{translations[language]?.serialNumber}</h3>
                                    <p>{device?.serial_number || '-'}</p>
                                </div>
                            </div>

                            <div className='flex-device-info'>
                                <div className="device-info-item">
                                    <h3 className='info-heading'>{translations[language]?.macAddress}</h3>
                                    <p>{device?.mac_address || '-'}</p>
                                </div>
                                <div className="device-info-item">
                                    <h3 className='info-heading'>{translations[language]?.deviceId || 'Device ID'}</h3>
                                    <p>{device?.ud_sn && !['NULL', 'null', 'undefined'].includes(device.ud_sn) ? device.ud_sn : '-'}</p>
                                </div>
                            </div>


                        </div>

                        <div className='information-section-drawer'>
                            {renderDeviceSpecificFields(device)}
                        </div>
                    </div>
                ))}
            </div>
        </Drawer>
    )
}

export default DeviceDrawer